var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9985C2 6.47617 6.47692 2 12 2C17.5231 2 22 6.47617 22 11.9993C22 17.5223 17.5231 21.9993 12 21.9993C6.47692 21.9985 2 17.5223 2 11.9985ZM12 18.6404C15.6691 18.6404 18.6404 15.6676 18.6404 11.9985C18.6404 8.33019 15.6683 5.35731 12 5.35731C8.33168 5.35731 5.35881 8.33019 5.35881 11.9985C5.35806 15.6676 8.33168 18.6404 12 18.6404ZM12 15.3843C13.9042 15.3843 15.4487 13.8398 15.4487 11.9341C15.4487 10.0298 13.9042 8.48606 12 8.48606C10.095 8.48606 8.55126 10.0298 8.55126 11.9341C8.55126 13.8398 10.0943 15.3843 12 15.3843Z",
    fill: "#CF0A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.15fa6849.svg";
export { ForwardRef as ReactComponent };